import { useNavigate } from "react-router-dom";
import ArrowBtn from "../../../components/arrowbtn/ArrowBtn";
import { baseUrl } from "../../../utils/apiData";
import "./HomeLanding.scss";

const HomeLanding = ({data}) => {
  const navigate = useNavigate();
  const bookdemo = () => {
   navigate("/contactus")
  };

  return (
    <section className="home_landing">
      <div className="content_wrap p_bottom">
        <div className="bi_grid">
          <div className="left">
            <h1 className="wow fadeInUp">{data?.main_title || "-"}</h1>            
            <p className="wow fadeInUp">{data?.main_heading  || "-"}</p>
            <p className="wow fadeInUp" data-wow-delay="0.15s">
             {data?.main_description || "-"}
            </p>
            <ArrowBtn
              text="Get in touch"
              handleClick={bookdemo}
              theme="secondary_ternery"
              classList="wow fadeInUp"
            />
          </div>
          <div className="img_wrap">
            <img src={`${baseUrl}/${data?.main_image}`} alt="farsight" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeLanding;
